var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6654 12.1596L17.1741 12.7107C17.3279 12.5687 17.4154 12.3689 17.4154 12.1596H16.6654ZM11.2487 17.1596V17.9096C11.4372 17.9096 11.6189 17.8386 11.7574 17.7107L11.2487 17.1596ZM6.33203 4.57623H13.6654V3.07623H6.33203V4.57623ZM4.08203 14.1596V6.82623H2.58203V14.1596H4.08203ZM15.9154 6.82623V12.1596H17.4154V6.82623H15.9154ZM11.2487 16.4096H6.33203V17.9096H11.2487V16.4096ZM16.1567 11.6085L10.74 16.6085L11.7574 17.7107L17.1741 12.7107L16.1567 11.6085ZM11.9987 17.1596V14.1596H10.4987V17.1596H11.9987ZM13.2487 12.9096H16.6654V11.4096H13.2487V12.9096ZM2.58203 14.1596C2.58203 16.2306 4.26096 17.9096 6.33203 17.9096V16.4096C5.08939 16.4096 4.08203 15.4022 4.08203 14.1596H2.58203ZM13.6654 4.57623C14.908 4.57623 15.9154 5.58359 15.9154 6.82623H17.4154C17.4154 4.75517 15.7364 3.07623 13.6654 3.07623V4.57623ZM11.9987 14.1596C11.9987 13.4692 12.5583 12.9096 13.2487 12.9096V11.4096C11.7299 11.4096 10.4987 12.6408 10.4987 14.1596H11.9987ZM6.33203 3.07623C4.26096 3.07623 2.58203 4.75516 2.58203 6.82623H4.08203C4.08203 5.58359 5.08939 4.57623 6.33203 4.57623V3.07623Z",
    fill: "#858FA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 7.15961H13.3346",
    stroke: "#858FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 10.4929H10.0013",
    stroke: "#858FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.8c030094b60773b6f9ebd020a4a1c52e.svg";
export { ForwardRef as ReactComponent };